export default __webpack_public_path__ + "static/media/raml.c9959b47.svg";